import React from 'react'
import { Switch, Route } from 'react-router-dom'
import collectionContainer from '../modules/collection/containers/collectionContainer'
import EditCollectionContainer from '../modules/collection/containers/editCollectionContainer'

export default ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}`} component={collectionContainer} />
    <Route path={`${match.path}/new`} component={EditCollectionContainer} />
    <Route path={`${match.path}/edit/:id`} component={EditCollectionContainer} />
  </Switch>
)
